export default __webpack_public_path__ + "static/media/bm.2fe09134.svg";